import iconCody from '../../../img/icon-cody.svg'

export const SeparatorCody = () => (
    <div className='flex flex-row items-center h-28'>
        <div className='grow mr-2 border-b border-secondary'></div>
        <img src={iconCody} className='filter-secondary h-4 w-4' />
        <div className='grow ml-2 border-b border-secondary'></div>
    </div>)